/* eslint-disable */
export default {
  forward: '轉接',
  ignore: '忽略',
  toVoicemail: '至語音信箱',
  answer: '回答',
  endAndAnswer: '結束並回答',
  holdAndAnswer: '保留通話並接聽',
  custom: '自訂',
  more: '更多',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
